import { BoundingBoxImageClass } from "domains/canvas/enum/BoundingBoxImageClass";

export const classifyImageTransparency = async (
  base64Image: string
): Promise<BoundingBoxImageClass> => {
  // Create an image element and set the source to the base64 string
  const img = new Image();
  img.src = base64Image;
  img.crossOrigin = "anonymous";

  if (base64Image === "") {
    return BoundingBoxImageClass.CompletelyTransparent;
  }

  await new Promise((resolve, reject) => {
    img.onload = () => {
      resolve(true);
    };

    img.onerror = () => {
      reject("Could not load image");
    };
  });

  // Create a canvas element and draw the image onto it
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");

  if (ctx === null) {
    console.error("Could not get canvas context");
    throw new Error("Could not get canvas context");
  }

  ctx.drawImage(img, 0, 0);

  // Get the image data from the canvas
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = imageData.data;

  // Initialize counters for transparent and non-transparent pixels
  let transparentPixels = 0;
  let nonTransparentPixels = 0;

  // Loop through each pixel and determine its transparency
  for (let i = 3; i < pixels.length; i += 4) {
    const alpha = pixels[i];
    if (alpha === 0) {
      transparentPixels++;
    } else {
      nonTransparentPixels++;
    }
  }

  if (nonTransparentPixels === 0) {
    return BoundingBoxImageClass.CompletelyTransparent;
  } else if (transparentPixels === 0) {
    return BoundingBoxImageClass.ZeroTransparent;
  } else {
    return BoundingBoxImageClass.InnerAndOuterTransparent;
  }
};
